import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class LocalizacionService {

  constructor(private config:ConfigService, private http:HttpClient) { }

  getCountries(token: string) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Localizacion/Pais";
    return this.http.get(url,requestOptions);
  }


  getDeptos(token: string, idCountry:number) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Localizacion/Departamento/" + idCountry;
    return this.http.get(url,requestOptions);
  }

  getCities(token: string, idDepto:number) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Localizacion/Ciudad/" + idDepto;
    return this.http.get(url,requestOptions);
  }

  getCitiesId(token: string, idCity:number) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Localizacion/" + idCity;
    return this.http.get(url,requestOptions);
  }
}
